import Banner from "./Banner";
import Terms from "./Terms";

const TermsConditions = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Terms language={language} />
    </>
  );
};

export default TermsConditions;